import { render, staticRenderFns } from "./qiyegaikuo.vue?vue&type=template&id=61482730"
import script from "./qiyegaikuo.vue?vue&type=script&lang=js"
export * from "./qiyegaikuo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports